interface Props {
	title: string
	hint?: string
	children: React.ReactNode
}

export function SheetSection({ title, hint, children }: Props) {
	return (
		<section className="rounded-lg border border-border bg-card p-4">
			<h3 className="text-[13px] font-semibold text-foreground">{title}</h3>
			{hint && <p className="mt-0.5 text-xs text-neutral-600">{hint}</p>}
			<div className="mt-3">{children}</div>
		</section>
	)
}
